import React from 'react';

import { Card, CardContent, Grid, TextField } from '@mui/material';

import Footer from './components/Footer';
import Navbar from './components/Navbar';

import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

function ProductsServices(props) {

    // const containerRef = React.useRef(null);
    const [containerRef,containerInView] = useInView({
        triggerOnce : true,
    });

    const [SearchText,setSearchTxt] = React.useState("");

    const data = [
        {
            name : 'Motley3D',
            subtitle : 'Web 3D',
            description : "Experience high quality 3D Visualizations on the web. Now Visualizing your projects and plans just got easier."
        },
        {
            name : 'MotleyAR',
            subtitle : 'Augmented Reality',
            description : "Our Augmented views are top shelf. The future lies in AR. With MotleyAR, Data can now be seen in the real world."
        },
        {
            name : 'MotleyAV',
            subtitle : 'ArchViz',
            description : "MotleyAV or ArchViz is our dynamic product where in we deliver high quality assets and renders in the AEC space."
        },
        {
            name : 'MotleyCV',
            subtitle : 'Computer Vision',
            description : "Computer Vision are the eyes of Artificial Intelligence. MotleyCV leverages Computer Vision to develop AI based projects."
        },
        {
            name : 'MotleyPV',
            subtitle : 'Pilot View',
            description : "Our Pilot View is based around the principle of user control. Total user control along with minimal system requirements makes our platform best to use."
        },
        {
            name : 'MotleyVR',
            subtitle : 'Virtual Reality',
            description : "We can only perceive what we can see. MotleyVR helps in connecting the world virtually. With MotleyVR, Imagination to reality gap is reduced drastically."
        }
    ];

    return (
        <div>

            <div className='pad-10'>
                <h1 className='mFont' style={{textAlign:'center',fontWeight:900}}>Products {"&"} Services</h1>
                <div style={{marginTop:30,marginBottom:30}}>
                    <TextField 
                        type='text'
                        variant='outlined'
                        fullWidth 
                        placeholder='Search by Product Name...' 
                        label='Search by Product Name' 
                        value={SearchText} 
                        onChange={(e)=>{setSearchTxt(e.target.value);}} 
                    />
                </div>

                <Grid container spacing={2} style={{marginTop:10}} ref={containerRef}>
                    {
                        data.map(d =>(
                            d.name.toLowerCase().search(SearchText.toLowerCase()) !== -1 &&
                            <Grid item sm={12} lg={4}>
                                <motion.div animate={{y: containerInView && 0 }} transition={{from:200,duration:2}}>
                                <Card sx={{ minWidth: 345 }}>
                                    <CardContent>
                                        <h2 className='mFont'>{d.name}</h2>
                                        <h5 className='mFont'>{d.subtitle}</h5>
                                        <p className='mFont'>{d.description}</p>
                                    </CardContent>
                                </Card>
                                </motion.div>
                            </Grid>
                        ))
                    }
                </Grid>
            </div>   

            <Navbar 
                homeRef={props.homeRef} 
                aboutRef={props.aboutRef} 
                techRef={props.techRef} 
                indusRef={props.indusRef} 
                contactRef={props.contactRef} 
                scrollToRef={props.scrollToRef}
                />
            <Footer/>
        </div>
    );
}

export default ProductsServices;